(function () {
  /**
   * @param {HTMLElement} section
   */
  function initJourneyModals(section) {
    const dialog = section.querySelector('[data-sw-journey-dialog]');
    const content = section.querySelector('[data-sw-journey-content]');
    if (!dialog || !content) return;

    section.querySelectorAll('[data-sw-journey-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.dataset.journeyTarget;
        if (!targetId) return;

        const template = section.querySelector(`#${CSS.escape(targetId)}`);
        if (!template || !(template instanceof HTMLTemplateElement)) return;

        content.replaceChildren(template.content.cloneNode(true));
        dialog.showModal();
      });
    });

    section.querySelectorAll('[data-sw-journey-close]').forEach((control) => {
      control.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', (event) => {
      const panel = dialog.querySelector('.sw-journey-modal__panel');
      if (event.target === dialog || (panel && !panel.contains(event.target))) {
        dialog.close();
      }
    });

    dialog.addEventListener('cancel', () => {
      dialog.close();
    });

    dialog.addEventListener('close', () => {
      content.replaceChildren();
    });
  }

  /**
   * @param {HTMLElement} section
   */
  function initCarousel(section) {
    const track = section.querySelector('[data-sw-testimonials-track]');
    const slides = Array.from(section.querySelectorAll('[data-sw-testimonials-slide]'));
    const prevBtn = section.querySelector('[data-sw-testimonials-prev]');
    const nextBtn = section.querySelector('[data-sw-testimonials-next]');
    const dots = Array.from(section.querySelectorAll('[data-sw-testimonials-dot]'));

    if (!track || slides.length < 2) return;

    let activeIndex = 0;

    const getVisibleCount = () => (window.innerWidth >= 750 ? 3 : 1);

    const getMaxIndex = () => Math.max(0, slides.length - getVisibleCount());

    const getSlideOffset = (index) => {
      const slide = slides[index];
      return slide ? slide.offsetLeft : 0;
    };

    const getActiveIndexFromScroll = () => {
      const scrollLeft = track.scrollLeft;
      let index = 0;

      slides.forEach((slide, i) => {
        if (slide.offsetLeft <= scrollLeft + 4) {
          index = i;
        }
      });

      return Math.min(index, getMaxIndex());
    };

    const updateUI = () => {
      const maxIndex = getMaxIndex();
      activeIndex = Math.min(activeIndex, maxIndex);

      dots.forEach((dot) => {
        const pageIndex = parseInt(dot.dataset.swTestimonialsDot, 10);
        const isValidPage = !Number.isNaN(pageIndex) && pageIndex <= maxIndex;

        dot.hidden = !isValidPage;
        dot.classList.toggle('is-active', pageIndex === activeIndex);
        dot.setAttribute('aria-selected', pageIndex === activeIndex ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= maxIndex;
    };

    const goTo = (index) => {
      activeIndex = Math.max(0, Math.min(index, getMaxIndex()));
      track.scrollTo({ left: getSlideOffset(activeIndex), behavior: 'smooth' });
      updateUI();
    };

    prevBtn?.addEventListener('click', () => goTo(activeIndex - 1));
    nextBtn?.addEventListener('click', () => goTo(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.swTestimonialsDot, 10);
        if (!Number.isNaN(index)) goTo(index);
      });
    });

    let scrollTimeout;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        activeIndex = getActiveIndexFromScroll();
        updateUI();
      }, 80);
    });

    window.addEventListener('resize', () => {
      activeIndex = Math.min(activeIndex, getMaxIndex());
      track.scrollTo({ left: getSlideOffset(activeIndex), behavior: 'auto' });
      updateUI();
    });

    updateUI();
  }

  const sections = document.querySelectorAll('[data-sw-testimonials]');
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section instanceof HTMLElement) {
      initJourneyModals(section);
      initCarousel(section);
    }
  });
})();
